"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var material_1 = require("@angular/material");
var reset_password_component_1 = require("../reset-password/reset-password.component");
var ResetPasswordHolderComponent = /** @class */ (function () {
    function ResetPasswordHolderComponent(dialog) {
        this.dialog = dialog;
    }
    ResetPasswordHolderComponent.prototype.ngAfterViewInit = function () {
        var dialogRef = this.dialog.open(reset_password_component_1.ResetPasswordComponent, {
            width: "450px",
            disableClose: false,
        });
        dialogRef.afterClosed().subscribe(function (v) {
            if (!dialogRef.componentInstance.afterRegClose) {
                window.history.back();
            }
        });
    };
    ResetPasswordHolderComponent.prototype.ngOnInit = function () {
    };
    return ResetPasswordHolderComponent;
}());
exports.ResetPasswordHolderComponent = ResetPasswordHolderComponent;
